export default "__VITE_ASSET__Bu5vH$Lv__"